import React from "react";
import { path } from "ramda";
import { Row, Col, } from "antd";
import { connect } from "react-redux";
import  { ReducerKeys } from "../../../reducers";
import SettingReducer from "../../../reducers/SettingReducer";
import Layout, { InlineDiv } from "../../../components/layout/Layout";
import I18n, { fromSyntax } from "../../../i18n";
import { OH1 } from "../../../components/text/OText";
import BarChart from "../../../components/chart/BarChart";
import {  Metrics } from "../../../theme";
import { DataVisualizeKeys } from "../../../theme/Colors";
import { isAlive,ArrayUtil, DateUtil, ReportUtil, RouteUtil } from "../../../util";
import { BreadcrumbPath } from "../../../components/navigation/OBreadcrumb";
import DatePickerCompare from "../DatePickerCompare";
import QuestionMapping from "../../../resources/stress/question_mapping";
import ReportAction from "../../../actions/ReportAction";
import { ContainerLoading, PreloadDiv } from "../../../components/loading/PersistGateLoading";
import QuestionDetailPanel from "./Panels/QuestionDetailPanel";
import UpgradePlanWarning from "../../UpgradePlanWarning";

const createQuestion = ()=>(
	Array.from(QuestionMapping, (q,q_index)=>({
		title: `Question ${q_index+1}`,
		question: I18n.t(`questions.user_stress_test.question.q_${q.name}`),
		choices:Array.from(q.choices,(c, c_index)=>({
			text:I18n.t(`questions.user_stress_test.answer.${c.name}`),
			value: 10, //((c_index+1)*10),
			ratio: 1 //(c_index+1) / q.choices.length
		}))
	}))
);
const ViewMode = {
	/**
     * Display all question.
     */
	LIST:"list",
	/**
     * Display one question with percentage and other detail.
     */
	DETAIL:"detail",
	/**
     * Display one question with percentage and other detail
     * and choice detail.
     */
	CHOICE:"choice",
};
const LoadingKey={
	NONE:undefined,
	QUESTION_LIST:"question_list",
	CHOICE_DETAIL:"choice_detail"
};
const TargetValue = {
	Primary:"primary",
	Secondary:"secondary"
};
class StressIndividualPanel extends React.Component{
    state= {}
    texts={}

    questionIndex = 0;
    breadcrumb_paths = ["EMPTY"];
	questionLabels = [];
    detailPanelValues = {
    	[TargetValue.Primary]:{
    		panel: null,
    		choiceValue:[],
    	},
    	[TargetValue.Secondary]:{
    		panel: null,
    		choiceValue:[],
    	}
    };
	privousPrimarySummary = undefined;

	constructor(props){
    	super(props);
    	this.questionLabels = createQuestion();
    	this.texts = {
    		stress_test:I18n.t("siderTap.stress_test"),
    		individual_question:I18n.t("siderTap.individual_question"),
    		select_interval:I18n.t("select_interval"),
    		vs:I18n.t("vs"),
    		question_path_syntax:I18n.t("question_path_syntax"),
    		question_label_syntax:I18n.t("question_label_syntax"),
    		choice_path_syntax:I18n.t("choice_path_syntax"),
    		user:I18n.t("user"),
		};
		const { primary, secondary } = ReportUtil.toMomentCompareDate(props.reportDate);
    	this.state = {
    		viewMode: ViewMode.LIST,
    		questionPath:[this.texts.individual_question],
    		choicePath:[this.texts.individual_question],
    		loading:LoadingKey.QUESTION_LIST,
    		dateRanges:{
    			[TargetValue.Primary]: primary || DateUtil.getAllTimeDateRange(),
    			[TargetValue.Secondary]: secondary || []
    		}
    	};
    	this.initQuestion(props);
	}
	componentWillReceiveProps(props){
    	this.initQuestion(props);
	}
	componentDidMount(){
    	const dateRange = path(["dateRanges",TargetValue.Primary], this.state);
    	this.fetchQuestionList(dateRange, TargetValue.Primary);
	}
	initQuestion(props){
    	this.clearQuestionBreadcrumb();
	}
    fetchQuestionList = (dateRange, type = TargetValue.Primary)=>new Promise((resolve, reject)=>{
    	this.setState({loading:LoadingKey.QUESTION_LIST});
    	ReportAction.fetchStressQuestionAndAnswer({dateRange})
    		.then(res=>{
    			// Put choice count to each question.
    			const q_values = Object.values(res);
    			const questionChoiceValue = [];
    			for(let i=0;i<q_values.length;i+=1){
    				const choices_count = Object.values(q_values[i]);
    				let max = 0;
    				const choiceValues = [];
    				choices_count.forEach(element => {
    					if(element>max)
    						max = element;
    				});
    				for(let c =0;c<choices_count.length;c+=1){
    					choiceValues.push({
    						value: choices_count[c],
    						ratio: choices_count[c] / max
    					});
    					if(type === TargetValue.Primary){
    						this.questionLabels[i].choices[c].value = choices_count[c];
    						this.questionLabels[i].choices[c].ratio = choices_count[c] / max;
    					}
    				}
    				questionChoiceValue.push(choiceValues);
    			}
    			this.detailPanelValues[type].choiceValue = questionChoiceValue;
    			this.setState({loading:LoadingKey.NONE});
    			resolve();
    		})
    		.catch(err=>{
    			console.error("fetchQuestionList.error: ",err);
    			reject();
    			this.setState({loading:LoadingKey.NONE});
    		});
    });
    clearQuestionBreadcrumb(){
    	this.breadcrumb_paths = [
    		{text: this.texts.individual_question, value:0, onClick:this.openQuestionList}
    	];
    }
    setQuestionIndex(index = 0){
    	this.questionIndex = index;
    	this.breadcrumb_paths = [
    		{
    			text: this.texts.individual_question,
    			value:0,
    			onClick:this.openQuestionList
    		},
    		{
    			text: fromSyntax(this.texts.question_path_syntax, {index:index+1, user:this.texts.user}),
    			value:index,
    			onClick:this.openQuestionDetail
    		}
    	];
    }
    createQuestionWithValue(index, type = TargetValue.Primary){
    	const choiceValues = this.detailPanelValues[type].choiceValue[index];
    	if(ArrayUtil.isAliveArray(choiceValues)){
    		const copyQuestion = { ...this.questionLabels[index] };
    		const bakeChoiceValues = [];
    		for(let c =0;c<choiceValues.length;c+=1){
    			bakeChoiceValues.push({
    				text:copyQuestion.choices[c].text,
    				...choiceValues[c]
    			});
    		}
    		copyQuestion.choices = bakeChoiceValues;
    		return copyQuestion;
    	}
    	return this.questionLabels[index];
    }
    openQuestionList = ()=>{
    	this.clearQuestionBreadcrumb();
    	this.setState({viewMode:ViewMode.LIST});
    }
    openQuestionDetail = (breadcrumb_question)=>{
    	this.setQuestionIndex(breadcrumb_question.value);
    	// console.log('open question detail index ',breadcrumb_question.value);
    	this.setState({viewMode:ViewMode.DETAIL});
    }
    onQuestionClick = (q_index)=>{
    	// console.log('Question click: ',q_index);
    	this.setState({viewMode: ViewMode.DETAIL});
    	this.setQuestionIndex(q_index);
    }
	onPrimaryFetchedDetail = (summary)=>{
		this.privousPrimarySummary = summary;
		this.forceUpdate();
	}
    onHeadDateRangeChange = (dates)=>{
    	const { setReportDate } = this.props;
    	const { viewMode } = this.state;
    	const dateRanges = {
    		primary:dates,
    		secondary:this.state.dateRanges.secondary
    	};
    	setReportDate(ReportUtil.createSaveCompareDate(dateRanges));
    	this.setState({dateRanges});
    	this.fetchQuestionList(dates, TargetValue.Primary).then(()=>{
    		const target_panel = this.detailPanelValues[TargetValue.Primary];
    		if(viewMode !== ViewMode.LIST && isAlive(target_panel.panel)){
    			target_panel.panel.fetchChoiceDetailOfDate(dates);
    		}
    	});
    }
    onTailDateRangeChange = (dates)=>{
    	const { setReportDate } = this.props;
    	const { viewMode } = this.state;
    	const dateRanges = {
    		primary:this.state.dateRanges.primary,
    		secondary:dates
    	};
    	this.setState({dateRanges});
    	setReportDate(ReportUtil.createSaveCompareDate(dateRanges));
    	this.fetchQuestionList(dates, TargetValue.Secondary).then(()=>{
    		if(ArrayUtil.isAliveArray(dates)){
    			const target_panel = this.detailPanelValues[TargetValue.Secondary];
    			if(isAlive(target_panel.panel)){
    				target_panel.panel.fetchChoiceDetailOfDate(dates);
    			}
    		}
    	});
    }
    render(){
    	const { viewMode, loading,
    		dateRanges:{ primary, secondary }
    	} = this.state;
    	const dateFormat = "DD MMM YYYY";
    	const showCompare = ArrayUtil.isAliveArray(secondary);
    	const compareSpanSize = 24 / ( showCompare ? 2 : 1);
    	const	canEnterThisRoute = RouteUtil.CheckRoutePermission();
			
    	return (
    		<Layout>
    			<OH1>{this.texts.stress_test}</OH1>
    			<BreadcrumbPath path={this.breadcrumb_paths}/>
    			{canEnterThisRoute?
    				<React.Fragment>
    					<DatePickerCompare
    						displayFormat={dateFormat}
    						headDate={primary}
    						tailDate={secondary}
    						onHeadDateChange={this.onHeadDateRangeChange}
    						onTailDateChange={this.onTailDateRangeChange}
    						showTail={viewMode!==ViewMode.LIST}
    					/>
    					{ viewMode === ViewMode.LIST ?
    						<Row gutter={Metrics.button.bigSpaceMargin} style={{paddingTop:Metrics.button.bigSpaceMargin}}>
    							<Col>
    								<ContainerLoading isLoading={loading === LoadingKey.QUESTION_LIST}
    									loadingChildren={<PreloadDiv />}>
    									<BarChart questions={this.questionLabels}
    										onQuestionClick={this.onQuestionClick} />
    								</ContainerLoading>
    							</Col>
    						</Row>
    						:
    						<Row gutter={Metrics.button.bigSpaceMargin} style={{paddingTop:Metrics.button.bigSpaceMargin}}>
    							<Col key={TargetValue.Primary} span={compareSpanSize}>
    								<QuestionDetailPanel
    									setRef={(ref)=>{
    										this.detailPanelValues[TargetValue.Primary].panel = ref;
    									}}
    									questionIndex={this.questionIndex}
    									question={this.createQuestionWithValue(this.questionIndex, TargetValue.Primary)}
    									dateRange={primary}
    									onFetched={this.onPrimaryFetchedDetail}
    									colorType={DataVisualizeKeys.Primary}
    									isVertical = {showCompare}
    								/>
    							</Col>
    							{showCompare ? <Col key={TargetValue.Secondary} span={compareSpanSize}>
    								<QuestionDetailPanel
    									setRef={(ref)=>{
    										this.detailPanelValues[TargetValue.Secondary].panel = ref;
    									}}
    									questionIndex={this.questionIndex}
    									question={this.createQuestionWithValue(this.questionIndex, TargetValue.Secondary)}
    									compareQuestion={this.createQuestionWithValue(this.questionIndex, TargetValue.Primary)}
    									dateRange={secondary}
    									previousSummary={this.privousPrimarySummary}
    									colorType={DataVisualizeKeys.Secondary}
    									isVertical = {showCompare}
    								/>
    							</Col> : undefined}
    						</Row> }
    				</React.Fragment>
    				:<UpgradePlanWarning />
    			}
    		</Layout>
    	);
    }
}

// export default StressIndividualPanel;
const state2props = (state)=>{
	return {
		reportDate: path([ReducerKeys.SETTING,"reportDate"], state)
	};
};
const mapDispatch = dispatch=>({
	setReportDate: reportDate=>dispatch(SettingReducer.setReportDate(reportDate))
});
export default connect(state2props, mapDispatch)(StressIndividualPanel);



// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Stress/StressIndividual.js